import styled, {keyframes} from 'styled-components';

const scrollEffect = (height: number) => keyframes`
    0% {
        transform: translateY(-${height}px) rotate(180deg);
    }
    40% {
        transform: translateY(0) rotate(180deg);
    }
    100% {
        transform: translateY(${height}px) rotate(180deg);
    }

`;

export const HomepageIntroContainer = styled.div`
    height: calc(100vh + 500px);
    width: 100%;
    position: relative;
    overflow: hidden;
    z-index: 8;
    pointer-events: none;
    background: #0f1129;

    & .homepageHeroCTA {
        color: ${(p) => p.theme.palette.text.primary};
    }

    &:not(.hasLoaded) {
        .gradient {
            opacity: 0 !important;
            transition: opacity.2s ease;
        }

        .video-container {
            opacity: 0 !important;
            transition: opacity.2s ease;
        }
    }

    &:before {
        content: '';
        position: absolute;
        top: -52px;
        left: 0;
        width: 100%;
        height: 20%;
        z-index: 50;
        opacity: 0.75;
        background: linear-gradient(180deg, #0d0f26 0%, rgba(0, 0, 0, 0) 100%);
    }

    .gradient {
        position: absolute;
        top: -400px;
        left: -130px;
        width: 70%;
        height: 3000px;
        z-index: 1;
        transform: rotate(340deg);
        opacity: 0.7;
        background: linear-gradient(90deg, #0d0f26 0%, rgba(0, 0, 0, 0) 100%);
    }

    &.isComplete {
        .video-container {
            position: absolute;
            bottom: -400px;
            @media screen and (min-width: 1900px) {
                bottom: -800px;
            }
            @media screen and (max-width: 1200px) {
                bottom: -500px;
            }
            overflow: hidden;
        }
        .content {
            pointer-events: none;
        }
    }

    .video-container {
        position: fixed;
        width: 100vw;
        height: 100vh;
        bottom: 0;
        left: 0;
        overflow: hidden;
        .video-ratio {
            padding-bottom: 56.25%;
            position: relative;
            overflow: hidden;
            .video-size {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                .video-container {
                    background: none !important;
                }
                .video.background-video {
                    background: none !important;
                    video {
                        width: 100%;
                        object-fit: cover;
                        object-position: 50% 0;
                    }
                }
            }
        }
    }

    .content {
        position: fixed;
        bottom: 10%;
        width: 700px;
        left: 5%;
        right: 0;
        pointer-events: all;
        z-index: 100;
        margin: 0;
        transition: 0.5s ease;
    }
`;

export const IntroScrollIndicator = styled.div`
    position: relative;
    color: ${(p) => p.theme.palette.accent.sky};
    svg {
        position: absolute;
        top: 0;
        left: 0;
        animation-name: ${(p) => scrollEffect(40)};
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: ${(p) => p.theme.easing};
    }

    h4 {
        display: inline-block;
        margin: 0 0 0 35px;
    }
`;
